<div class="modal-header">
  <div class="header-actions">
    <button mat-icon-button class="header-icon-btn" (click)="togglePreferences()">
      <mat-icon>{{preferencesMode ? 'arrow_back' : 'timer'}}</mat-icon>
    </button>
    @if (canViewStatistics) {
      <button type="button" mat-icon-button class="header-icon-btn statistics-trigger" [class.active]="statisticsMode"
        [attr.aria-label]="'POSTURE_STATS.OPEN_STATISTICS' | translate" [attr.title]="'POSTURE_STATS.OPEN_STATISTICS' | translate"
        [attr.aria-pressed]="statisticsMode" aria-controls="room-posture-statistics" (click)="toggleStatistics()">
        <mat-icon>bar_chart</mat-icon>
      </button>
    }
  </div>

  <h2 class="modal-title">
    {{preferencesMode ? ('Temporizzazione' | translate) : data.title}}
  </h2>

  <button mat-icon-button class="header-icon-btn close-btn" [mat-dialog-close]="false"
    [attr.aria-label]="'MENTORAGE_TUTORIAL.DEMO.CLOSE' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content [ngClass]="!preferencesMode ? 'soft-dialog-content' : 'dialog-content-preferences'">

  @if (data.tutorialMode) {
  <p class="tutorial-room-close-hint">
    <mat-icon>info_outline</mat-icon>
    {{'MENTORAGE_TUTORIAL.ROOM_CLOSE_HINT' | translate}}
  </p>
  }

  @if (!preferencesMode) {
  <div class="monitor-view fade-in" [hidden]="statisticsMode && canViewStatistics">
    <!-- Removed on 15/07/2026 to free up vertical space -->
    <!-- @if (data.beds.length) {
    <div class="beds-container">
      <div class="bed-chip" *ngFor="let bed of data.beds">
        <div class="bed-icon-circle">
          <mat-icon svgIcon="bed"></mat-icon>
        </div>
        <span class="bed-name">{{bed.name}}</span>
      </div>
    </div>
    } -->

    <div class="streaming-wrapper">
      <streaming [devices]="$any(data.devices)"></streaming>
    </div>

    <div *ngIf="getCurrentAllert() as alert" class="alert-management-card"
      [style.--alert-accent]="getAlertVisual(alert).accent" [style.--alert-border]="getAlertVisual(alert).border"
      [style.--alert-surface]="getAlertVisual(alert).surface"
      [style.--alert-icon-surface]="getAlertVisual(alert).iconSurface"
      [style.--alert-title-color]="getAlertVisual(alert).titleColor">

      <div class="alert-info-row">
        <div class="alert-label">
          <div class="alert-icon-badge">
            @if (getAlertVisual(alert).useSvgIcon) {
            <mat-icon [svgIcon]="getAlertVisual(alert).icon"></mat-icon>
            } @else {
            <mat-icon>{{getAlertVisual(alert).icon}}</mat-icon>
            }
          </div>
          <div class="alert-text-group">
            <span class="alert-eyebrow">Allerta attiva</span>
            <span class="alert-title">{{alert.eventType === '08' ? alert.title : (eventTypeToTranslation[alert.eventType] | translate)}}</span>
            @if (alert.eventType === '08') {
            <span class="alert-body">{{alert.body}}</span>
            }
          </div>
        </div>
        <span class="alert-time">{{getTimeLeft(alert.timestamp)}} min fa</span>
      </div>

      <div class="alert-actions">
        <ion-button expand="block" mode="md" class="manage-btn" [style.--background]="getAlertVisual(alert).button"
          [style.--background-hover]="getAlertVisual(alert).button" (click)="manageEvent(alert)"
          [disabled]="manageRunning">

          <span *ngIf="!manageRunning">Gestisci allerta</span>
          <div *ngIf="manageRunning" class="spinner-wrapper">
            <span>Gestione...</span>
            <ion-spinner name="crescent"></ion-spinner>
          </div>

        </ion-button>
      </div>
    </div>

  </div>
  @if (statisticsMode && canViewStatistics) {
    <nav class="statistics-tabs" [attr.aria-label]="'CONNECTIVITY.STATISTICS' | translate">
      @if (canViewPostureStatistics) { <button type="button" [class.active]="statisticsTab === 'postures'" [attr.aria-pressed]="statisticsTab === 'postures'" (click)="statisticsTab = 'postures'">{{'CONNECTIVITY.POSTURES' | translate}}</button> }
      @if (canViewConnectivityStatistics) { <button type="button" [class.active]="statisticsTab === 'connectivity' || !canViewPostureStatistics" [attr.aria-pressed]="statisticsTab === 'connectivity' || !canViewPostureStatistics" (click)="statisticsTab = 'connectivity'">{{'CONNECTIVITY.TAB' | translate}}</button> }
    </nav>
    <section id="room-posture-statistics" class="statistics-view" [attr.aria-label]="'CONNECTIVITY.STATISTICS' | translate">
      @if (statisticsTab === 'postures' && canViewPostureStatistics) {
      @defer (on immediate) {
        <app-posture-statistics [buildingId]="statisticsBuildingId" [roomId]="data.roomId" [alwaysExpanded]="true" [dialogLayout]="true"></app-posture-statistics>
      }
      } @else if (canViewConnectivityStatistics) {
        @if (connectivityDevices.length > 1) {
          <mat-form-field appearance="outline" class="connectivity-device-select">
            <mat-label>{{'CONNECTIVITY.SENSOR' | translate}}</mat-label>
            <mat-select [value]="connectivityDevice?.id" (selectionChange)="selectedConnectivityDeviceId = $event.value">
              @for (device of connectivityDevices; track device.id) { <mat-option [value]="device.id">{{device.label}} · {{device.macAddress}}</mat-option> }
            </mat-select>
          </mat-form-field>
        }
        @if (connectivityDevice; as device) {
          @defer (on immediate) {
          <app-sensor-connectivity layout="sensor" [deviceId]="device.id" [buildingId]="statisticsBuildingId" [unitId]="device.facilities?.unit?.id"></app-sensor-connectivity>
          }
        } @else { <p>{{'CONNECTIVITY.NO_SENSORS' | translate}}</p> }
      }
    </section>
  }
  }

  @else {
  <div class="settings-view fade-in">
    @if (deviceSettings) {
    <timingComponentsGroup (onSubmitData)="submitDevicesSettings($event)" [deviceSettings]="deviceSettings"
      [deviceSettingsMode]="deviceSettingsMode" [isMobile]="isMobile" [beds]="data.beds">
    </timingComponentsGroup>
    } @else {
    <div class="loading-settings">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Caricamento impostazioni...</p>
    </div>
    }
  </div>
  }

</mat-dialog-content>
